import { useQuery } from '@tanstack/react-query';
import { toast } from 'react-toastify';

import EudrDashboardService from 'src/modules/3rd-party-management/apis/admin/EudrDashboardService';

export const EUDR_TOP_RELEVANT_PRODUCTS_BY_RISK_LEVEL_QUERY_KEY = '3rd-party-management-fetch-eudr-top-relevant-products-by-risk-level';

const useTopRelevantProductsByRiskLevel = ({
    t,
}) => {
    const query = useQuery({
        queryKey: [EUDR_TOP_RELEVANT_PRODUCTS_BY_RISK_LEVEL_QUERY_KEY],
        queryFn: async () => {
            const service = EudrDashboardService.getInstance();

            return await service.fetchTopRelevantProductsByRiskLevel();
        },
        cacheTime: 0,
        refetchOnWindowFocus: false,
        onError: (error) => {
            if (process.env.NODE_ENV === 'development') console.error(error);

            toast(t('An error occurred while fetching EUDR top relevant products by risk level data.'), {
                type: 'error',
            });
        },
    });

    const data = query.data;

    if (!data) {
        return {
            ...query,
            products: null,
            riskSummary: null,
        };
    }

    return {
        ...query,
        products: (data.products || []).map((item) => ({
            product: t(item.product),
            quantity: Number(item.quantity) || 0,
            percentage: Number(item.percentage) || 0,
            color: item.color,
        })),
        riskSummary: (data.riskSummary || []).map((item) => ({
            riskLevel: t(item.riskLevel),
            percentage: Number(item.percentage) || 0,
            landEvaluated: Number(item.landEvaluated) || 0,
        })),
    };
};

export default useTopRelevantProductsByRiskLevel;
